import AssignNewTaskModal from './AssignNewTaskModal.view';

export default AssignNewTaskModal;
